import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import ThemeContext from "./context/ThemeContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./jsx/pages/Loader/Loader";
import ErrorBoundary from "./ErrorBoundary/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <BrowserRouter>
        <ThemeContext>
          {/* <ErrorBoundary> */}
          <App />
          {/* </ErrorBoundary> */}
          <ToastContainer />
        </ThemeContext>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();
